import { create } from 'zustand'
import type { Me } from '../lib/api'

interface UserState {
  me: Me | null
  loading: boolean
  error: string | null
  setMe: (me: Me) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  /** Flip has_photo locally after a successful upload — avoids a full /me refetch. */
  setHasPhoto: (v: boolean) => void
  /** Mark profile complete locally after createProfile/updateProfile — avoids a full /me refetch. */
  setProfileComplete: (v: boolean) => void
  /** Flip is_paused locally after a successful setPause call — avoids a full /me refetch. */
  setPaused: (v: boolean) => void
  /** Flip crown_hidden locally after a successful setCrownHidden call — avoids a full /me refetch. */
  setCrownHidden: (v: boolean) => void
}

export const useUserStore = create<UserState>((set) => ({
  me: null,
  loading: true,
  error: null,
  setMe: (me) => set({ me, loading: false, error: null }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error, loading: false }),
  setHasPhoto: (v) =>
    set((s) => (s.me ? { me: { ...s.me, has_photo: v } } : {})),
  setProfileComplete: (v) =>
    set((s) => (s.me ? { me: { ...s.me, profile_complete: v } } : {})),
  setPaused: (v) =>
    set((s) => (s.me ? { me: { ...s.me, is_paused: v } } : {})),
  setCrownHidden: (v) =>
    set((s) => (s.me ? { me: { ...s.me, crown_hidden: v } } : {})),
}))
